<template>
  <Teleport to="body">
    <div v-if="modelValue" class="order-calc-modal" @click.self="close">
      <button class="order-calc-modal-close" type="button" aria-label="닫기" @click="close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18"/><path d="M6 6l12 12"/></svg>
      </button>
      <div class="order-calc-modal-inner">
        <HomeOrderCalculator hide-subtext @ordered="close" />
      </div>
    </div>
  </Teleport>
</template>

<script>
import HomeOrderCalculator from './Home/HomeOrderCalculator.vue'

export default {
  name: 'OrderCalculatorModal',
  components: {
    HomeOrderCalculator
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue(open) {
      // body만 막으면 실제 스크롤 컨테이너가 html(documentElement)인 경우
      // 배경이 그대로 스크롤된다 — 둘 다 잠가야 한다
      document.documentElement.style.overflow = open ? 'hidden' : ''
      document.body.style.overflow = open ? 'hidden' : ''
    },
    '$route'() {
      // 계산기에서 주문하기를 누르면 /service/inputform 으로 이동한다 —
      // 어떤 이유로든 라우트가 바뀌면 모달이 새 페이지 위에 남아있지 않도록 닫는다
      if (this.modelValue) this.close()
    }
  },
  beforeUnmount() {
    document.documentElement.style.overflow = ''
    document.body.style.overflow = ''
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false)
    }
  }
}
</script>

<style scoped>
.order-calc-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(20, 20, 20, 0.45);
  padding: 20px;
  box-sizing: border-box;
}

.order-calc-modal-inner {
  width: 100%;
  max-width: 552px;
  max-height: 100%;
  overflow-y: auto;
  border-radius: var(--radius-xl);
}

.order-calc-modal-close {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: none;
  color: var(--white);
  cursor: pointer;
}

.order-calc-modal-close svg {
  width: 100%;
  height: 100%;
}

.order-calc-modal-close:hover {
  color: var(--ink-200);
}
</style>
